module.exports = __webpack_public_path__ + "img/logo-bao-tang-ha-noi.83a4866d.jpg";